import { render, staticRenderFns } from "./c-formulario.vue?vue&type=template&id=0d720703&scoped=true&"
import script from "./c-formulario.vue?vue&type=script&lang=js&"
export * from "./c-formulario.vue?vue&type=script&lang=js&"
import style0 from "./c-formulario.vue?vue&type=style&index=0&id=0d720703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d720703",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VSnackbar,VTextField,VTextarea})
